import React from 'react'
import { STEPS } from '../../options'
import Progress from '../Progress'

import { Step1, Step2 } from './Steps'
import { ArrowBack } from '@material-ui/icons'
import { AUTH_METHOD } from '../../../../../constants'

const FormSteps = ({
  authMethod,
  classes,
  fields,
  setFields,
  onChange,
  onSubmit,
  step,
  countries,
  setStep,
  t,
  isEDDMUser,
  userCountry,
  shouldRestrictToEddmOnly,
  setShouldRestrictToEddmOnly,
  toolsParams,
}) => {
  return (
    <form id="sign-up-form" className="content-inner">
      <div className={classes.progressBar}>
        {step === STEPS.STEP_2 && authMethod === AUTH_METHOD.OPPIZI && (
          <ArrowBack onClick={() => setStep(STEPS.STEP_1)} />
        )}
        <Progress step={step} hasSteps={true} />
      </div>
      <Step1
        title={t('title')}
        fields={fields}
        onChange={onChange}
        setStep={setStep}
        authMethod={authMethod}
        isShow={step === STEPS.STEP_1}
        isEDDMUser={isEDDMUser}
        userCountry={userCountry}
        shouldRestrictToEddmOnly={shouldRestrictToEddmOnly}
        setShouldRestrictToEddmOnly={setShouldRestrictToEddmOnly}
        toolsParams={toolsParams}
      />
      <Step2
        authMethod={authMethod}
        fields={fields}
        onChange={onChange}
        countries={countries}
        onSubmit={onSubmit}
        setStep={setStep}
        classes={classes}
        isShow={step === STEPS.STEP_2}
        setFields={setFields}
        isEDDMUser={isEDDMUser}
        userCountry={userCountry}
        shouldRestrictToEddmOnly={shouldRestrictToEddmOnly}
      />
    </form>
  )
}

export default FormSteps
